import { ComponentInteractionsProvider } from '@utils/component-framework';
import { IArkContent } from '../root.content/_content.js';
import { jsx } from 'react/jsx-runtime';

function EmbedWrapper(props) {
  return /*#__PURE__*/jsx(ComponentInteractionsProvider, {
    onActivate: props.onActivate,
    children: /*#__PURE__*/jsx(IArkContent, {
      ...props
    })
  });
}

export { EmbedWrapper };
//# sourceMappingURL=variant.embed.js.map
